import * as React from 'react'

const ChevronDown = ({className, style}) => {
    return (<svg width="16" height="16" viewBox="0 0 16 16" className={`${className} docsIcon`} style={style} xmlns="http://www.w3.org/2000/svg">
        <path d="M11.9393 4.93935L7.99997 8.87872L4.06056 4.93935L3 6L7.99997 11L13 6L11.9393 4.93935Z" />
    </svg>)
}

export default ChevronDown;